export const urlByLang = (lang: string): string => lang === window.DEFAULT_LOCALE ? '' : lang;
